import type { FC } from 'react';
import { EventTicketMenu } from '@widgets/events';
import { Contacts } from '@features/event-page';
import { Header } from '@features/events';
import { Directions } from '@features/events/common/directions';
import { EventInfo } from '@features/events/event-tickets';
import { ArrowShortLeft } from '@shared/assets';
import { Card, IconButton } from '@shared/ui';
import type { Event } from '@src/library/models/events';
import { Loader } from 'library/components/common';
import { useEvent, useMyTickets } from 'library/hooks/events';
import * as st from './styles.module.scss';

export const TicketsPage: FC = () => {
  const tickets = useMyTickets();
  const event = useEvent();
  const ticket = tickets.tickets[0];

  return (
    <>
      <Header
        title="Мой билет"
        left={
          <IconButton variant="dark" onClick={tickets.onClose}>
            <ArrowShortLeft />
          </IconButton>
        }
        right={<EventTicketMenu />}
      />
      {tickets.status === 'loading' && <Loader text="Загрузка билета..." />}
      {event.status === 'loaded' && tickets.status === 'loaded' && (
        <section className={st.body}>
          <Card className={st.card}>
            <div className={st.ticket}>
              <EventInfo
                eventInfo={event.event as Event}
                firstName={ticket.first_name || ''}
                middleName={ticket.middle_name || ''}
                lastName={ticket.last_name || ''}
              />
              <Directions />
              {event?.event?.contacts && (
                <div>
                  <Contacts contacts={event?.event?.contacts} />
                </div>
              )}
            </div>
          </Card>
        </section>
      )}
    </>
  );
};
